export default "__VITE_ASSET__bb21bc99__"